import {Action} from '@ngrx/store';
import {User} from '@app/core/models/user.model';
import {Group} from '@app/core/models/group.model';
import {IGroupFilter} from '@app/modules/shared/services/group.service';
import {Department} from '@app/core/models/department.model';
import {ISupplementalSalaryFilter} from '@app/core/services/api/supplementalSalary.service';
import {SupplementalSalary} from '@app/core/models/supplementalSalary.model';
import {Pagination} from '@app/core/models/pagination.model';
import {IEmployeeSalaryCalculation} from '@app/core/store/state/employees.state';

export enum EEmployeesActions {
	GetUsers = '[Employees] Get users',
	GetUsersSuccess = '[Employees] Get users success',

	SetSocialSecurityNumber = '[Employees] Set Social Security Number',

	GetSocialSecurityNumber = '[Employees] Get Social Security Number',
	GetSocialSecurityNumberSuccess = '[Employees] Get Social Security Number success',

	GetUser = '[Employees] Get user',
	GetUserSuccess = '[Employees] Get user success',

	PostUser = '[Employees] Post User',
	PostUserSuccess = '[Employees] Post User success',

	PatchUser = '[Employees] Patch User',
	PatchUserSuccess = '[Employees] Patch User success',

	PatchProfile = '[Employees] Patch Profile',
	PatchProfileSuccess = '[Employees] Patch Profile success',

	DeleteUser = '[Employees] Delete User',
	DeleteUserSuccess = '[Employees] Delete user success',

	DeactivateUser = '[Employees] Deactivate user',
	DeactivateUserSuccess = '[Employees] Deactivate user success',

	ActivateUser = '[Employees] Activate user',
	ActivateUserSuccess = '[Employees] Activate user success',

	SendActivationMail = '[Employees] Send activation mail',
	SendActivationMailSuccess = '[Employees] Send activation mail success',

	SetEditingUser = '[Employees] Set editing user',

	GetGroups = '[Employees] Get groups',
	GetGroupsSuccess = '[Employees] Get groups success',

	GetGroup = '[Employees] Get group',
	GetGroupSuccess = '[Employees] Get group success',

	GetAllGroups = '[Employees] Get all groups',
	GetAllGroupsSuccess = '[Employees] Get all groups success',

	PostGroup = '[Employees] Post group',
	PostGroupSuccess = '[Employees] Post group success',

	PatchGroup = '[Employees] Patch group',
	PatchGroupSuccess = '[Employees] Patch group success',

	PatchGroupFiles = '[Employees] Patch group files',
	PatchGroupFilesSuccess = '[Employees] Patch group files success',

	DeleteGroup = '[Employees] Delete group',
	DeleteGroupSuccess = '[Employees] Delete group success',

	SetEditingGroup = '[Employees] Set editing group',

	SetIsSeeingEmployees = '[Employees] Set is seeing employees',
	SetShowAllUsers = '[Employees] Set show active users',

	SetDepartmentsFilter = '[Employees] Set departments filter',

	SetShouldReloadUsers = '[Employees] Set should reload users',
	SetShouldReloadGroups = '[Employees] Set should reload groups',

	SetEmployeeSearchQuery = '[Employees] Set employee search query',

	GetInformationForCreatingUser = '[Employees] Get information for creating user',
	GetInformationForCreatingUserSuccess = '[Employees] Get information for creating user success',

	SetDepartments = '[Employees] Set departments',

	GetEmployeeSupplementalSalaries = '[Employees] Get Employee Supplemental Salaries',
	GetGroupsSupplementalSalaries = '[Employees] Get Group Supplemental Salaries',
	GetEmployeeSupplementalSalariesSuccess = '[Employees] Get Employee Supplemental Salaries Success',

	GetEmployeeSupplementalSalariesWithGroups = '[Employees] Get Employee Supplemental Salaries With Groups',
	GetEmployeeSupplementalSalariesWithGroupsSuccess = '[Employees] Get Employee Supplemental Salaries With Groups Success',

	GetEmployeeSalaryTotalsCalculation = '[Employees] Get Employee Salary Totals Calculation',
	GetEmployeeSalaryTotalsCalculationSuccess = '[Employees] Get Employee Salary Totals Calculation Success',

	RemoveGroupForSupplemetalSalary = '[Employees] Remove Group For Supplemental Salary',

	ClearAutoSupplementalSalaries = '[Employees] Clear Auto Supplemental Salaries',

	ClearSupplementalSalaries = '[Employees] Clear Supplemental Salaries',
}

export class GetUsers implements Action {
	public readonly type = EEmployeesActions.GetUsers;
	public departmentIdsFormatted;

	constructor(public departmentIds: number[], public includeDeactivated: boolean) {
		this.departmentIdsFormatted = departmentIds.join(',');
	}
}

export class GetUsersSuccess implements Action {
	public readonly type = EEmployeesActions.GetUsersSuccess;

	constructor(public users: User[]) {
	}
}

export class GetUser implements Action {
	public readonly type = EEmployeesActions.GetUser;

	constructor(public userId: number) {
	}
}

export class GetUserSuccess implements Action {
	public readonly type = EEmployeesActions.GetUserSuccess;

	constructor(public user: User) {
	}
}

export class PostUser implements Action {
	public readonly type = EEmployeesActions.PostUser;

	constructor(public payload: { [key: string]: any }) {
	}
}

export class PostUserSuccess implements Action {
	public readonly type = EEmployeesActions.PostUserSuccess;

	constructor() {
	}
}

export class PatchUser implements Action {
	public readonly type = EEmployeesActions.PatchUser;

	constructor(public userId: number, public payload: { [key: string]: any }, public emailChanged: boolean) {
	}
}

export class PatchUserSuccess implements Action {
	public readonly type = EEmployeesActions.PatchUserSuccess;

	constructor() {
	}
}

export class PatchProfile implements Action {
	public readonly type = EEmployeesActions.PatchProfile;

	constructor(public payload: { [key: string]: any }) {
	}
}

export class PatchProfileSuccess implements Action {
	public readonly type = EEmployeesActions.PatchProfileSuccess;

	constructor() {
	}
}

export class DeleteUser implements Action {
	public readonly type = EEmployeesActions.DeleteUser;

	constructor(public userId: number) {
	}
}

export class DeleteUserSuccess implements Action {
	public readonly type = EEmployeesActions.DeleteUserSuccess;

	constructor() {
	}
}

export class DeactivateUser implements Action {
	public readonly type = EEmployeesActions.DeactivateUser;

	constructor(public userId: number) {
	}
}

export class DeactivateUserSuccess implements Action {
	public readonly type = EEmployeesActions.DeactivateUserSuccess;

	constructor() {
	}
}

export class ActivateUser implements Action {
	public readonly type = EEmployeesActions.ActivateUser;

	constructor(public userId: number) {
	}
}

export class ActivateUserSuccess implements Action {
	public readonly type = EEmployeesActions.ActivateUserSuccess;

	constructor() {
	}
}

export class SendActivationMail implements Action {
	public readonly type = EEmployeesActions.SendActivationMail;

	constructor(public user: User) {
	}
}

export class SendActivationMailSuccess implements Action {
	public readonly type = EEmployeesActions.SendActivationMailSuccess;

	constructor() {
	}
}

export class SetEditingUser implements Action {
	public readonly type = EEmployeesActions.SetEditingUser;

	constructor(public user: User) {
	}
}

export class GetGroups implements Action {
	public readonly type = EEmployeesActions.GetGroups;
	public departmentIdsFormatted;

	constructor(public departmentIds: number[]) {
		this.departmentIdsFormatted = departmentIds.join(',');
	}
}

export class GetGroupsSuccess implements Action {
	public readonly type = EEmployeesActions.GetGroupsSuccess;

	constructor(public groups: Group[]) {
	}
}

export class GetAllGroups implements Action {
	public readonly type = EEmployeesActions.GetAllGroups;

	constructor() {
	}
}

export class GetAllGroupsSuccess implements Action {
	public readonly type = EEmployeesActions.GetAllGroupsSuccess;

	constructor(public groups: Group[]) {
	}
}

export class GetGroup implements Action {
	public readonly type = EEmployeesActions.GetGroup;
	public filters: IGroupFilter = {};

	constructor(public groupId: string, public user: User) {
		if (user.permission_level === 2) {
			this.filters = {
				include: 'supplemental_salaries, file_entries, users, department',
				append: 'available_users',
			};
		} else {
			this.filters = {
				include: 'users, file_entries',
			};
		}
	}
}

export class GetGroupSuccess implements Action {
	public readonly type = EEmployeesActions.GetGroupSuccess;

	constructor(public group: Group) {
	}
}

export class PostGroup implements Action {
	public readonly type = EEmployeesActions.PostGroup;

	constructor(public payload: {}) {
	}
}

export class PostGroupSuccess implements Action {
	public readonly type = EEmployeesActions.PostGroupSuccess;

	constructor() {
	}
}

export class PatchGroup implements Action {
	public readonly type = EEmployeesActions.PatchGroup;

	constructor(public groupId: string, public payload: { [key: string]: any }) {
	}
}

export class PatchGroupSuccess implements Action {
	public readonly type = EEmployeesActions.PatchGroupSuccess;

	constructor() {
	}
}

export class PatchGroupFiles implements Action {
	public readonly type = EEmployeesActions.PatchGroupFiles;

	constructor(public groupId: string, public payload: { [key: string]: any }) {
	}
}

export class PatchGroupFilesSuccess implements Action {
	public readonly type = EEmployeesActions.PatchGroupFilesSuccess;

	constructor() {
	}
}

export class DeleteGroup implements Action {
	public readonly type = EEmployeesActions.DeleteGroup;

	constructor(public groupId: number | string) {
	}
}

export class DeleteGroupSuccess implements Action {
	public readonly type = EEmployeesActions.DeleteGroupSuccess;

	constructor() {
	}
}

export class SetEditingGroup implements Action {
	public readonly type = EEmployeesActions.SetEditingGroup;

	constructor(public group: Group) {
	}
}

export class SetIsSeeingEmployees implements Action {
	public readonly type = EEmployeesActions.SetIsSeeingEmployees;

	constructor(public isSeeingEmployees: boolean) {
	}
}

export class SetShowAllUsers implements Action {
	public readonly type = EEmployeesActions.SetShowAllUsers;

	constructor(public showAllUsers: boolean) {
	}
}

export class SetDepartmentsFilter implements Action {
	public readonly type = EEmployeesActions.SetDepartmentsFilter;

	constructor(public filter: number[]) {
	}
}

export class SetShouldReloadUsers implements Action {
	public readonly type = EEmployeesActions.SetShouldReloadUsers;

	constructor(public shouldReload: boolean) {
	}
}

export class SetShouldReloadGroups implements Action {
	public readonly type = EEmployeesActions.SetShouldReloadGroups;

	constructor(public shouldReload: boolean) {
	}
}

export class SetEmployeeSearchQuery implements Action {
	public readonly type = EEmployeesActions.SetEmployeeSearchQuery;

	constructor(public searchQuery: string) {
	}
}

export class GetInformationForCreatingUser implements Action {
	public readonly type = EEmployeesActions.GetInformationForCreatingUser;

	constructor() {
	}
}

export class GetInformationForCreatingUserSuccess implements Action {
	public readonly type = EEmployeesActions.GetInformationForCreatingUserSuccess;

	constructor(public departments: Department[]) {
	}
}

export class GetSocialSecurityNumber implements Action {
	public readonly type = EEmployeesActions.GetSocialSecurityNumber;

	constructor(public userId: number) {
	}
}

export class GetSocialSecurityNumberSuccess implements Action {
	public readonly type = EEmployeesActions.GetSocialSecurityNumberSuccess;

	constructor(public socialSecurityNumber: string) {
	}
}

export class SetSocialSecurityNumber implements Action {
	public readonly type = EEmployeesActions.SetSocialSecurityNumber;

	constructor(public socialSecurityNumber: string | null) {
	}
}

export class SetDepartments implements Action {
	public readonly type = EEmployeesActions.SetDepartments;

	constructor(public departments: Department[]) {
	}
}

export class GetEmployeeSupplementalSalaries implements Action {
	public readonly type = EEmployeesActions.GetEmployeeSupplementalSalaries;
	public filters: ISupplementalSalaryFilter = {};

	constructor(public user: User, public page: number, public page_size: number) {
		this.filters = {
			include: 'groups,group_users',
			'filter[users.id]': user.id,
		};
	}
}

export class GetGroupsSupplementalSalaries implements Action {
	public readonly type = EEmployeesActions.GetGroupsSupplementalSalaries;
	public filters: ISupplementalSalaryFilter = {};

	constructor(public group: Group, public page: number, public page_size: number) {
		this.filters = {
			include: 'groups,group_users',
			'filter[groups.id]': group.id,
		};
	}
}

export class GetEmployeeSupplementalSalariesWithGroups implements Action {
	public readonly type = EEmployeesActions.GetEmployeeSupplementalSalariesWithGroups;
	public filters: ISupplementalSalaryFilter = {};

	constructor(public groups: Group[], public page: number, public page_size: number) {
		this.filters = {
			include: 'groups,group_users',
			'filter[groups.id]': groups.map(group => group.id)?.join(','),
			'filter[auto_add_new_users]': 1,
			sort: '-active',
		};
	}
}

export class GetEmployeeSupplementalSalariesWithGroupsSuccess implements Action {
	public readonly type = EEmployeesActions.GetEmployeeSupplementalSalariesWithGroupsSuccess;
	public filters: ISupplementalSalaryFilter = {};

	constructor(public supplementalSalaries: SupplementalSalary[], public pagination: Pagination) {
	}
}

export class GetEmployeeSupplementalSalariesSuccess implements Action {
	public readonly type = EEmployeesActions.GetEmployeeSupplementalSalariesSuccess;

	constructor(public supplementalSalaries: SupplementalSalary[], public pagination: Pagination) {
	}
}

export class GetEmployeeSalaryTotalsCalculation implements Action {
	public readonly type = EEmployeesActions.GetEmployeeSalaryTotalsCalculation;

	constructor(public userId: number, public year: number, public month: number, public includeShifts: boolean = false) {
	}
}

export class GetEmployeeSalaryTotalsCalculationSuccess implements Action {
	public readonly type = EEmployeesActions.GetEmployeeSalaryTotalsCalculationSuccess;

	constructor(public month: number, public salaryTotalsCalc: IEmployeeSalaryCalculation) {
	}
}

export class RemoveGroupForSupplemetalSalary implements Action {
	public readonly type = EEmployeesActions.RemoveGroupForSupplemetalSalary;

	constructor(public group: Group) {
	}
}

export class ClearAutoSupplementalSalaries implements Action {
	public readonly type = EEmployeesActions.ClearAutoSupplementalSalaries;

	constructor() {
	}
}

export class ClearSupplementalSalaries implements Action {
	public readonly type = EEmployeesActions.ClearSupplementalSalaries;

	constructor() {
	}
}

export type EmployeesActions =
	GetUsers |
	GetUsersSuccess |
	GetUser |
	GetUserSuccess |
	PostUser |
	PostUserSuccess |
	PatchUser |
	PatchUserSuccess |
	PatchProfile |
	PatchProfileSuccess |
	DeleteUser |
	DeleteUserSuccess |
	DeactivateUser |
	DeactivateUserSuccess |
	ActivateUser |
	ActivateUserSuccess |
	SendActivationMail |
	SendActivationMailSuccess |
	SetEditingUser |
	GetGroups |
	GetGroupsSuccess |
	GetAllGroups |
	GetAllGroupsSuccess |
	GetGroup |
	GetGroupSuccess |
	PostGroup |
	PostGroupSuccess |
	PatchGroup |
	PatchGroupSuccess |
	PatchGroupFiles |
	PatchGroupFilesSuccess |
	DeleteGroup |
	DeleteGroupSuccess |
	SetEditingGroup |
	SetIsSeeingEmployees |
	SetShowAllUsers |
	SetDepartmentsFilter |
	SetShouldReloadUsers |
	SetShouldReloadGroups |
	SetEmployeeSearchQuery |
	GetInformationForCreatingUser |
	GetInformationForCreatingUserSuccess |
	GetSocialSecurityNumber |
	GetSocialSecurityNumberSuccess |
	SetSocialSecurityNumber |
	SetDepartments |
	GetEmployeeSupplementalSalaries |
	GetGroupsSupplementalSalaries |
	GetEmployeeSupplementalSalariesSuccess |
	GetEmployeeSupplementalSalariesWithGroups |
	GetEmployeeSupplementalSalariesWithGroupsSuccess |
	RemoveGroupForSupplemetalSalary |
	ClearAutoSupplementalSalaries |
	ClearSupplementalSalaries |
	GetEmployeeSalaryTotalsCalculation |
	GetEmployeeSalaryTotalsCalculationSuccess
	;
